var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"grey lighten-3"},[_c('v-toolbar',{staticClass:"darken-3",attrs:{"color":"primary"}},[_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("Búsqueda de Legajos")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('legajo-lista',{attrs:{"show-add":false,"all-filters":""}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a394620a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/herramientas/BuscadorLegajo.vue
// module id = null
// module chunks = 